////////This is the doctor js code
$(".hello-doctor-wrapper").animate({height: "80px"});
	 window.setTimeout( closeHelloDoctor, 10000 );

$(".hello-doctor-wrapper-doctors-show").animate({height: "80px"});
	 window.setTimeout( closeHelloDoctorDoctorsShow, 10000 );
	 
$(".hello-doctor-button").click(function(){
  closeHelloDoctor();
});

function closeHelloDoctor() {
  $(".hello-doctor-wrapper").animate({height: "0"});
}

function closeHelloDoctorDoctorsShow() {
  $(".hello-doctor-wrapper-doctors-show").animate({height: "0"});
}

/* Resizing YouTube videos */

$(function() {

    var $allVideos = $("iframe[src^='//player.vimeo.com'], iframe[src^='//www.youtube.com'], iframe[src^='//www.youtube-nocookie.com'], object, embed"),
    $fluidEl = $("fluid-video");

	$allVideos.each(function() {

	  $(this)
	    // jQuery .data does not work on object/embed elements
	    .attr('data-aspectRatio', this.height / this.width)
	    .removeAttr('height')
	    .removeAttr('width');

	});

	$(window).resize(function() {

	  var newWidth = $fluidEl.width();
	  $allVideos.each(function() {

	    var $el = $(this);
	    $el
	        .width(newWidth)
	        .height(newWidth * $el.attr('data-aspectRatio'));

	  });

	}).resize();

});

/////////////THEME CODE
var windowSize = $(window).width();

if(windowSize <= 991 ) {
 	$("#image-coffee").attr("src","//eversmilewhite.com/cdn/shop/t/59/assets/coffee_small.jpg?v=41393");
    $("#image-couple").attr("src","//eversmilewhite.com/cdn/shop/t/59/assets/couple_small.jpg?v=41393");
}

if(windowSize <= 600 ) {
 	$("#image-coffee").attr("src","//eversmilewhite.com/cdn/shop/t/59/assets/coffe_smiling.jpg?v=41393");
    $("#image-couple").attr("src","//eversmilewhite.com/cdn/shop/t/59/assets/couple.jpg?v=41393");
}
                            
'use strict';

if (window.jQuery) var $ = window.jQuery;

$(function () {
  aweHosoren.init();

  //== DEMO ONLY
  aweSearchMenubar();
  
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}

// ===

function aweSearchMenubar() {
  var $navbar = $('.awemenu-nav');

  var $searchForm = $('#menubar-search-form');
  var $openSearch = $('#open-search-form .icon-search');
  var $closeSearch = $('#close-search-form');

  $openSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.addClass('open');

    setTimeout(function() {
      $searchForm.find('input').focus();
    }, 250);
  });

  $closeSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.removeClass('open');
  });


  $(window).resize(function() {
    if ($navbar.hasClass('awemenu-mobile')) {
      $searchForm.width('100%');
      $searchForm.css({right: '0'});
    } else {
      var $awemenu = $('.awemenu-nav .awemenu');
      var $aweicon = $('.awemenu-nav .navbar-icons');

      var width = $awemenu.width() + 50;
      var offsetRight = $aweicon.width() + 20;

      $searchForm.width(width);
      $searchForm.css({right: offsetRight});
    }
  }).trigger('resize');

}

$(document).click(function (e){
  var container = $("#menubar-search-form");
  var container2=$("#open-search-form");
  if (!container.is(e.target) && !container2.is(e.target) && container.has(e.target).length === 0  && container2.has(e.target).length === 0){ 
    $('#menubar-search-form').removeClass('open');
  }
});


// ===
function aweMainSlider() {
  var $slider = $('.main-slider');

  $slider.owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    autoplay: true,
    onInitialized: function() {
      $slider.find('.owl-item').each(function() {
        var $owlItem = $(this);

        var $mainSlide = $owlItem.find('.main-slider-item');
        var $mainImage = $owlItem.find('.main-slider-image > img');

        if ($mainSlide.length && $mainImage.length) {
          $mainSlide.addClass('background');
          $mainSlide.css('background-image', 'url('+$mainImage.attr('src')+')');

          $mainImage.css({
            opacity: 0,
            visibility: 'hidden'
          });
        }
      });
    }
  });
}

function awePriceSlider($selector) {
  if (! $selector) {
    $selector = $('#price-slider');
  }

  $selector.slider({
    values: [35, 250],
    min: 10,
    max: 320,
    step: 10,
    range: true,
    slide: function(e, ui) {
      $('#amount').text('$'+ui.value);
    }
  });
}

function aweBlogMasonry($selector) {
  if (! $selector) {
    $selector = $('.blog-masonry .row-masonry');
  }

  $selector.imagesLoaded(function() {
    $selector.masonry({
      itemSelector: '.column',
      columnWidth: '.column'
    });
  });
}

function aweProfolioIsotope($selector) {
  if (! $selector) {
    $selector = $('.grid');
  }

  $selector.imagesLoaded(function() {
    var $grid = $selector.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'masonry'
    });
  });

  $('.awe-nav').on('click', 'a', function(e) {
    e.preventDefault();

    $(this).parents('.awe-nav').find('li').removeClass('active');
    $(this).closest('li').addClass('active');

    var filter = $(this).attr('data-filter');
    $selector.isotope({ filter: filter });
  });
}

function aweProfolioDetail() {
  $('.lasted-portfolio-carousel').owlCarousel({
    items: 4,
    nav: true,
    dots: false,
    margin: 30,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      980: { items: 4 }
    }
  });

  $('.image').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: { enabled: true }
  });
}

function aweProductSidebar() {
  var $filterSidebar = $('#shop-widgets-filters');
  var $toggleButton = $('#open-filters');

  var $overlay = $('body').find('.widgets-filter-overlay');

  function _open() {
    $filterSidebar.addClass('open');
    $toggleButton.addClass('open');

    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }

    $('body').addClass('open-filters-open');
  }

  function _close() {
    $filterSidebar.removeClass('open');
    $toggleButton.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }

  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });

  $('html').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
}

function aweProductRender(thumbHorizontal) {
  if (Modernizr && ! Modernizr.touch) {
    $('.easyzoom').easyZoom();
  }

  var sMain = new Swiper('.product-slider-main', {
    loop: false,

    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  });

  var sThumb = new Swiper('.product-slider-thumbs', {
    loop: false,
    centeredSlides: true,
    spaceBetween: thumbHorizontal ? 15 : 0,
    slidesPerView: thumbHorizontal ? 4 : 3,
    direction: thumbHorizontal ? 'horizontal' : 'vertical',
    slideToClickedSlide: true
  });

  sMain.params.control = sThumb;
  sThumb.params.control = sMain;
}




var selectCallback = function(variant, selector) {
  if (variant) {
    if (variant.available) {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } else {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
//     if ( variant.compare_at_price > variant.price ) {
//       $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
//     } else {
//       $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
//     }        
  } else {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}

$(".swiper-container").each( function(){
  var config = {
    spaceBetween: $(this).data('margin'),
    slidesPerView: $(this).data('items'),
    direction: $(this).data('direction'),
    paginationClickable: true,
    grabCursor: true 
  };		
  var swiper = new Swiper(this, config);

});


// ================== New lable=============
$('.product .product-inner').each(function(){

  var pubDate = $(this).data("publish-date");
  var pubDate2=pubDate.substr(0, 10);
  var todayDate = new Date();
  var time1 = Date.parse(pubDate2);
  var time2 = Date.parse(todayDate);
  var time= Math.abs(time2 - time1);
  var a= 60*24*60*60*1000;

  if(time < a){
    $('.product .product-inner .new').show();

  }
});

$(document).ready(function(){
  if($(".product-body-list").children().length > 0){
  
    $('.view-mode .grid').removeClass('active');
     $('.view-mode .list').addClass('active');
  }
});




/* Promotion Countdown */
jQuery(document).ready(function($) {
  $.fn.ENGO_CountDown = function( options ) {
    return this.each(function() {
      // get instance of the ENGO_CountDown.
      new  $.ENGO_CountDown( this, options );
    });
  }
  $.ENGO_CountDown = function( obj, options ){
    var ddiff, gsecs;
    this.options = $.extend({
      autoStart           : true,
      LeadingZero:true,
      DisplayFormat:"<div><span>%%D%%</span> Days</div><div><span>%%H%%</span> Hours</div><div><span>%%M%%</span> Mins</div><div><span>%%S%%</span> Secs</div>",
      FinishMessage:"Expired",
      CountActive:true,
      TargetDate:null
    }, options || {} );
    if( this.options.TargetDate == null || this.options.TargetDate == '' ){
      return ;
    }
    this.timer  = null;
    this.element = obj;
    this.CountStepper = -1;
    this.CountStepper = Math.ceil(this.CountStepper);
    this.SetTimeOutPeriod = (Math.abs(this.CountStepper)-1)*1000 + 990;
    var dthen = new Date(this.options.TargetDate);
    var dnow = new Date();
    if( this.CountStepper > 0 ) {
      ddiff = new Date(dnow-dthen);
    }
    else {
      ddiff = new Date(dthen-dnow);
    }
    gsecs = Math.floor(ddiff.valueOf()/1000);
    this.CountBack(gsecs, this);
  };
  $.ENGO_CountDown.fn =  $.ENGO_CountDown.prototype;
  $.ENGO_CountDown.fn.extend =  $.ENGO_CountDown.extend = $.extend;
  $.ENGO_CountDown.fn.extend({
    calculateDate:function( secs, num1, num2 ){
      var s = ((Math.floor(secs/num1))%num2).toString();
      if ( this.options.LeadingZero && s.length < 2) {
        s = "0" + s;
      }
      return "<b>" + s + "</b>";
    },
    CountBack:function( secs, self ){
      var DisplayStr;
      if (secs < 0) {
        self.element.innerHTML = '<div class="labelexpired"> '+self.options.FinishMessage+"</div>";
        return;
      }
      clearInterval(self.timer);
      DisplayStr = self.options.DisplayFormat.replace(/%%D%%/g, self.calculateDate( secs,86400,100000) );
      DisplayStr = DisplayStr.replace(/%%H%%/g, self.calculateDate(secs,3600,24));
      DisplayStr = DisplayStr.replace(/%%M%%/g, self.calculateDate(secs,60,60));
      DisplayStr = DisplayStr.replace(/%%S%%/g, self.calculateDate(secs,1,60));
      self.element.innerHTML = DisplayStr;
      if (self.options.CountActive) {
        self.timer = null;
        self.timer =  setTimeout( function(){
          self.CountBack((secs+self.CountStepper),self);
        },( self.SetTimeOutPeriod ) );
      }
    }

  });

  function init_countdown() {
    /** Countdown **/
    $('[data-countdown="countdown"]').each(function(index, el) {
      var $this = $(this);
      var $date = $this.data('date').split("-");
      $this.ENGO_CountDown({
        TargetDate:$date[0]+"/"+$date[1]+"/"+$date[2]+" "+$date[3]+":"+$date[4]+":"+$date[5],
        DisplayFormat:"<li><span>%%D%% </span>days</li><li><span>%%H%% </span>hours</li><li><span>%%M%% </span>mins</li><li><span>%%S%% </span>secs</li>",
        FinishMessage: "Expired"
      });
    });

    
    
  }
  init_countdown();
});
    
      
/*advisors*/
var photo_dict = {
  "Michael Florman, DDS": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/micheal.jpg?3875210388115320661",
  "Yon Lai, DDS": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/yon.jpg?14780591460642798947",
  "Victor Lam, DDS": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/victor.jpg?16489555356504442561",
  "Jaime Ojeda": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/jaime.jpg?11455989165485062842",
  "Joshua Wallace": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/joshua.jpg?628109942039568464",
  "Camilo Triana": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/camilo.jpg?9739405332682835830",
  "Sidney Eubanks": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/sidney.jpg?13711803939454762208",
  "Dunia Gailani, DDS": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/dunia.jpg?10092664615682643518",
  "Greg Rosecrans, DDS": "https://cdn.shopify.com/s/files/1/0662/0303/t/4/assets/greg.jpg?2165644514626614690",
};

var description_dict = {
  "Michael Florman, DDS": "Dr. Michael Florman is an orthodontist and entrepreneur based in Los Angeles with distinction as a Top 1% Invisalign Provider. With over 25 years of consulting experience for Colgate, Arm & Hammer, Dentsply Sirona, Credit Suisse, and other publicly traded oral care companies, Dr. Florman sold his successful publishing company in 2006 with strategic exit. Dr. Florman currently operates one of the largest Invisalign practices in the world and is the founder and CEO of both EverSmile, Inc. and Smile Lab where he has invented multiple innovative oral care products with particular focus on patients undergoing orthodontic treatment, teeth whitening, and breath freshening.",
  "Yon Lai, DDS": "Dr. Yon H. Lai is an orthodontist and angel investor based in New York with an emphasis on Cleft Lip & Palate treatment. Dr. Lai has received numerous awards and accreditations for his work as a doctor, professor, and lecturer. Dr. Lai is a Clinical Professor at NYU Dental, is on the Board of Directors at Global Bank in New York, is on the Board of Directors as a Technical Advisor at MEM Dental products manufacturing company, and is the former President of NYU Orthodontic Alumni and Chinese American Dental associations.",
  "Victor Lam, DDS": "Dr. Lam has been practicing Orthodontics since 2003. He received his Orthodontics training and DDS degree from NYU, College of Dentistry and his Master of Health Science from John Hopkins University, School of Hygiene and Public Health. He also holds a BS in Biochemistry from the University of Maryland.",
  "Jaime Ojeda": "Jaime Ojeda is the President & CEO of Point of Care Decision Support, a clinical decision support SaaS company, and the Founder of GrowthOctane, a management consulting firm. Jaime has held senior leadership positions in companies from mid-stage (PE & VC backed) to Fortune 100.  He has a proven track record of driving transformational growth in healthcare technology, professional services, and consumer product businesses. Most recently, under his leadership he helped two companies - Patient Care Technology Systems and MentorMate – achieve record sales and profits leading to successful exits via strategic acquirers.  Prior to these successes, Jaime spent 15+ years at the 3M Company where he held several senior leadership roles. Jaime earned his B.S. and M.S. degrees both from the University of Michigan – Ann Arbor.  He is a 3M certified Six Sigma/Lean Black Belt, certified DFSS Marketing Black Belt, and authored six (6) granted U.S. patents.",
  "Joshua Wallace": "Joshua Wallace is an accomplished operations, management, and technology entrepreneur based in Los Angeles, CA. As President of EverSmile, Inc., Joshua has used his business, marketing, design, and tech savvy to increase sales over 450% as well as launch multiple innovative oral care products through international trade, competitive distribution contracts, opening new sales channels including retail, and management of talented teams. Joshua’s bachelor’s degree in computer science from UC Santa Cruz underscores his passion for technology and his dedication to running a business logically and efficiently. Starting out in team management in renewable energies, Joshua moved into foodservice equipment brokering before founding and running a successful IT business which served the needs of small businesses in the Orange County, CA area.",
  "Camilo Triana": "Camilo Triana is an experienced Los Angeles-based entrepreneur and salesman who has worked in the oral care, beauty, real estate, and foodservice industries throughout his career. As co-founder and Vice President of EverSmile, Inc., Camilo brought to market several unique products from inception and formulation to commercial success through marketing, social media, strategic investments, and both international and professional sales. Immigrating from Colombia at a young age, Camilo made the American Dream his reality by selling millions of dollars in Newport Coast properties for Marriott before moving on to brokering restaurant equipment deals with luxury hotels as well as performing sales consulting for plastic surgeons, esthetic spas, and dental offices.",
  "Sidney Eubanks": "Sidney Eubanks is an expert web and application developer based in the San Francisco Bay Area. As VP of Information Technology at EverBrands, Sidney has transformed internal systems to dramatically increase efficiency and managed digital marketing campaigns and web properties to increase revenue. As a front end web developer at eBay’s Magento Commerce, Sidney contributed to a team maintaining standards of excellence in web development, designed & implemented significant redesigns to company communications, and helped build Imagine 2016, an event for thousands of eCommerce developers. Sidney has achieved a Bachelors of Science from UC Santa Cruz in Computer Science underscoring his love and passion for technology.",
  "Dunia Gailani, DDS": "A Southern California native, Dr. Gailani attended UCLA where she earned a B.S. in molecular and cellular biology. Dr. Gailani then attended NYU College of Dentistry and Department of Orthodontics where she earned her D.D.S. degree and then went on to receive her orthodontic specialty degree. She has since been practicing in the LA area and has been involved in orthodontic clinical research and development with orthodontic manufacturers. Dr. Gailani is also active as a clinical advisor and head orthodontist to the largest dental services corporation in the Southwest United States. Her dedication is to the total health and happiness of every patient. She is looking forward to helping us create bright smiles that last a lifetime.",
  "Greg Rosecrans, DDS": "Dr. Rosecrans has practiced dentistry for the past 28 years in Bay City, Michigan. He graduated from The Ohio State University College of Dentistry in 1991 and is a member of the Michigan Dental Association where he served as a Delegate. Dr. Rosecrans is also a member of The American Dental Association, The Vedder Society and is a member and former President of The Saginaw Valley Dental Society. He is President and CEO of Smarter Dent, which is an innovative dental buying group, focused on helping independent practitioners work smarter and stay competitive. Dr. Rosecrans and his wife Kelly live in Bay City with their 2 children.",
};

$( '.bio-panel' ).click(function(event) {

  $('.bio-pop').css('display','flex');

  document.getElementById('bio-title').innerHTML = event.currentTarget.id;
  document.getElementById('bio-description').innerHTML = description_dict[event.currentTarget.id];
  document.getElementById('bio-image').innerHTML = '<img class="img" src="' + photo_dict[event.currentTarget.id] + '" alt="" width="100%" >';
});

$('.single-bio, .bio-x').on('click', function(e) {
    e.stopPropagation();
});

$( '.bio-pop, .bio-x' ).click(function(event) {
  $('.bio-pop').css('display','none');
});

$('#a, #michael-button-container, #b, #yon-button-container, #c, #victor-button-container, #d, #jaime-button-container, #e, #joshua-button-container, #f, #camilo-button-container, #g, #sidney-button-container, #h, #greg-button-container, #i, #dunia-button-container').mouseenter(function(){ //Open on hover
  
  var pid = $(this).parent().attr("id"); //parent id
  var buttonContainer = "#" + pid.split(" ")[0].toLowerCase() + '-button-container'; //create buttonid w/first name
  var viewBio = "#" + pid.split(" ")[0].toLowerCase() + '-view-bio'; //create view bio id with first name
  
  dropAllButThis(pid);
  
  //if not expanded, expand view bio and parent div to make enough space
  if( document.getElementById(pid).clientHeight != 100 ) {
    $(buttonContainer).animate({"margin-top":"-100px"}, 300);
    $(viewBio).animate({"height":"50px"}, 300);
  }
  
});      

function onMouseOut(event) {
  
  var pid = $(this).parent().attr("id"); 
  var buttonContainer = "#" + pid.split(" ")[0].toLowerCase() + '-button-container';
  var viewBio = "#" + pid.split(" ")[0].toLowerCase() + '-view-bio';
  
  if( event.toElement.id == "" ) {
    dropAll();
  }
  
};
      
function dropAll() {
  
  let buttonContainer; //create buttonid w/first name
  let viewBio; //create view bio id with first name
  var people = ["michael", "yon", "victor", "jaime", "greg", "dunia", "joshua", "camilo", "sidney"];

  for (var i = 0; i < people.length; i++) {
    buttonContainer = "#" + people[i] + '-button-container'; //create buttonid w/first name
 	viewBio = "#" + people[i] + '-view-bio'; //create view bio id with first name
    $(buttonContainer).animate({"margin-top":"-50px"}, 300);
    $(viewBio).animate({"height":"0px"}, 300);
  }
 
}

function dropAllButThis(currentDiv) {
  
  var current = currentDiv.split(" ")[0].toLowerCase();
  let buttonContainer; //create buttonid w/first name
  let viewBio; //create view bio id with first name
  var people = ["michael", "yon", "victor", "jaime", "greg", "dunia", "joshua", "camilo", "sidney"];

  for (var i = 0; i < people.length; i++) {
    if( people[i] != current ) {
        buttonContainer = "#" + people[i] + '-button-container'; //create buttonid w/first name
  		viewBio = "#" + people[i] + '-view-bio'; //create view bio id with first name
      	$(buttonContainer).animate({"margin-top":"-50px"}, 300);
   		$(viewBio).animate({"height":"0px"}, 300);
    }
  }
 
}

document.getElementById("a").addEventListener('mouseout',onMouseOut,true);
document.getElementById("b").addEventListener('mouseout',onMouseOut,true);
document.getElementById("c").addEventListener('mouseout',onMouseOut,true);
document.getElementById("d").addEventListener('mouseout',onMouseOut,true);
document.getElementById("e").addEventListener('mouseout',onMouseOut,true);
document.getElementById("f").addEventListener('mouseout',onMouseOut,true);
document.getElementById("g").addEventListener('mouseout',onMouseOut,true);
document.getElementById("h").addEventListener('mouseout',onMouseOut,true);
document.getElementById("i").addEventListener('mouseout',onMouseOut,true);
document.getElementById("michael-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("michael-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("michael-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("yon-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("yon-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("yon-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("victor-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("victor-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("victor-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("jaime-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("jaime-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("jaime-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("joshua-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("joshua-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("joshua-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("camilo-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("camilo-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("camilo-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("sidney-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("sidney-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("sidney-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("greg-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("greg-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("greg-view-bio").addEventListener('mouseout',onMouseOut,true);
document.getElementById("dunia-button-container").addEventListener('mouseout',onMouseOut,true);
document.getElementById("dunia-person-name").addEventListener('mouseout',onMouseOut,true);
document.getElementById("dunia-view-bio").addEventListener('mouseout',onMouseOut,true);
   
      
      